import React from 'react';
const Icon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"
        {...props} >
        <path d="M11.7083 11.0607C10.7912 11.5897 9.61896 11.2754 9.09 10.36C8.84982 9.94435 8.84982 9.4321 9.09 9.01646L10.9144 5.85919L12.4096 8.44676C12.9383 9.36165 12.6249 10.5319 11.7083 11.0607Z"
            stroke="currentColor" strokeWidth="1.2" />
        <path d="M8.65966 3.87098L4.91004 10.36C4.38108 11.2754 3.20881 11.5897 2.29173 11.0606C1.37514 10.5319 1.06175 9.36162 1.59042 8.44673L5.34004 1.95775C5.869 1.04235 7.04127 0.728057 7.95836 1.25708C8.87494 1.78582 9.18833 2.95609 8.65966 3.87098Z"
            stroke="currentColor" strokeWidth="1.2" />
    </svg>
);
export default Icon;